import AttachmentsUploadQueueItemModule from './queue-item.module'

export default AttachmentsUploadQueueItemModule
